import type { PreOrderData } from './preOrder';
import type { CheckoutData } from './types';

export type CheckoutPreOrderSummary = {
  total: number;
  deposit: number;
  balance: number;
  depositPercentage: number;
  currency: string;
};

/** Deposit amount to charge at payment, aligned with checkout display tax basis. */
export function getPreOrderChargeAmount(preOrderData: PreOrderData, showTax: boolean): number {
  return showTax ? preOrderData.deposit : preOrderData.deposit_net;
}

/**
 * Compute deposit/balance display amounts for pre-order checkout summary rows.
 * Balance is always computed from total − deposit (never totalBalance).
 */
export function getCheckoutPreOrderSummary(
  checkout: Pick<CheckoutData, 'totalPrice'>,
  preOrderData: PreOrderData,
  showTax: boolean
): CheckoutPreOrderSummary {
  const deposit = showTax ? preOrderData.deposit : preOrderData.deposit_net;
  const total = showTax ? checkout.totalPrice.gross.amount : checkout.totalPrice.net.amount;

  return {
    total,
    deposit,
    balance: total - deposit,
    depositPercentage: preOrderData.deposit_percentage,
    currency: checkout.totalPrice.currency,
  };
}
